<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<style>
/* Global styles are now handled in src/styles/global.css */
</style>